import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import {
    ActiveExtrasFilter, CreateExtraItemRequest,
    ExtraItemBaseModelPagingResult, ExtraItemModel,
    ExtraItemModelPagingResult,
    ExtrasFilter, UpdateExtraItemRequest
} from '../core';
import { IExtraItemRequest, IFoodPreferenceItem } from './models/models';

export class ExtrasService {
    public static $inject = ['http', 'retailerService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService) { }

    public getActiveExtras = (query: ActiveExtrasFilter) => {
        return this.http.get<ExtraItemBaseModelPagingResult>(this.retailerService.activeExtras(), { params: query });
    }

    public getExtraItem = (extraID: string) => {
        return this.http.get<ExtraItemModel>(this.retailerService.extras(extraID), null);
    }

    public getFoodPreferences = () => {
        return this.http.get<IFoodPreferenceItem[]>(this.retailerService.foodPreference());
    }

    public getAllergens = () => {
        return this.http.get<IFoodPreferenceItem[]>(this.retailerService.foodAllergens());
    }

    public getExtras = (query: ExtrasFilter) => {
        return this.http.get<ExtraItemModelPagingResult>(this.retailerService.extras(), { params: query });
    }

    public createOrUpdateExtra(extraModel: IExtraItemRequest, extraID?: string) {
        if (extraID == null) {
            return this.createExtra(extraModel);
        } else {
            return this.updateExtra(extraID, extraModel);
        }
    }

    public createExtra = (query: CreateExtraItemRequest) => {
        return this.http.post<number>(this.retailerService.extras(), query);
    }

    public updateExtra = (extraID: string, extraModel: UpdateExtraItemRequest) => {
        return this.http.put(this.retailerService.extras(extraID), extraModel);
    }

    public archiveExtra = (extraID: number) => {
        return this.http.put(this.retailerService.archiveExtra(extraID), null);
    }

    public restoreExtra = (extraID: number) => {
        return this.http.put(this.retailerService.restoreExtra(extraID), null);
    }

    public saveExtraImageUrl = () => {
        return this.retailerService.createExtraImage();
    }

    public getExtraImageUrl = (imageID: string) => {
        return this.retailerService.getExtraImage(imageID);
    }

    public checkExtraAlreadyExist(title: string, extraID?: string) {
        return this.http.get(this.retailerService.checkTitle(title, extraID));
    }
}

angular
    .module('naut')
    .service('extrasService', ExtrasService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/extras/extras.service.ts